import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card } from "antd";
import UserAvatar from "components/user/UserAvatar";
import CityJoinBtn from "./CityJoinBtn";

import { checkFollowedCities, fetchCityFollowers } from "redux/actions/app";

const CityMembersCard = ({ city }: any) => {
  const [members, setMembers] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<any>(0);
  const [page, setPage] = useState(1);
  const refreshData = () => {
    if (page === 1) {
      fetchCityFollowers(city.id, page, 9).then((res) => {
        setTotalCount(res.pager.total_count);
        setMembers(res.followers);
      });
    }
    setPage(1);
  };
  useEffect(() => {
    fetchCityFollowers(city.id, page, 9).then((res) => {
      setTotalCount(res.pager.total_count);
      setMembers(page === 1 ? res.followers : members.concat(res.followers));
    });
  }, [page]);
  return (
    <Card title={`城市居民（${totalCount}）`}>
      <div className="city-members-card">
        {members.length > 0 &&
          members.map((member: any) => <UserAvatar size={44} user={member} />)}
        {members.length >= 9 && (
          <div className="more" onClick={() => setPage(page + 1)}></div>
        )}
      </div>
      <CityJoinBtn large city={city} refresh={() => refreshData()} />
    </Card>
  );
};
const mapStateToProps = (state: any) => ({
  token: state.user.token,
  followedCities: state.app.followedCities,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators({ checkFollowedCities }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CityMembersCard);
